<div>
  <dx-button
    class="theme-button"
    stylingMode="text"
    [icon]="'fas fa-clipboard-user'"
    (onClick)="onButtonClick()"
    hint="Open Client Portal"
  />
</div>
